// extracted by mini-css-extract-plugin
export default {"title":"D4-z","warning":"E4-z","sizeOptionsLegendText":"F4-z"};